import styled from 'styled-components';

import { min } from '../../utils/breakpoints';

const StyledTitle = styled.h3`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.dark};
  margin-bottom: 2px;
  text-align: center;

  ${min.sm} {
    text-align: left;
    font-size: 16px;
    margin-bottom: 5px;
  }
`;

export default StyledTitle;
